import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './BannerSales.scss';
import Form from 'react-bootstrap/Form';
import { BsSearch } from 'react-icons/bs';
import { InputGroup } from 'react-bootstrap';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  filterTokensAction,
  sortingTokensAction,
  setFilterInputAction,
} from '../../../store/token/tokenActions';
import {
  getSalesTitleFromPath,
  getSalesTypeFromPath,
  salesTypes,
} from '../../../helpers/salesRoute';
import { getSortKeyField } from '../../../pages/Sales/salesConstants';

function BannerSales({ ...props }) {
  const {
    filterTokens,
    sortingTokens,
    filterInput,
    setFilterInput,
    history,
    tokenSortData,
  } = props;
  const pathname = history?.location?.pathname?.toLowerCase();
  const salesTitle = getSalesTitleFromPath(pathname, 'Token Sales');
  const salesType = getSalesTypeFromPath(pathname) || salesTypes.TOKEN;
  const isNftSalesPage = salesType === salesTypes.NFT;
  const searchPlaceholder = isNftSalesPage
    ? 'Search by project name, NFT name or NFT contract address...'
    : 'Search by project name, token symbol or token contract address...';

  useEffect(() => {
    filterTokens();
    sortingTokens({
      sortKeyField: getSortKeyField(salesType, tokenSortData?.sortKey),
    });
  }, [
    filterInput,
    salesType,
    tokenSortData,
    filterTokens,
    sortingTokens,
  ]);

  return (
    <Container className="sales-banner text-white">
      <Row className="text-fs-head-xs">
        <Col>{`Home/${salesTitle}`}</Col>
      </Row>
      <Row className="text-fs-title-md mt-4">
        <Col lg={4} md={6}>
          {`MercurX ${salesTitle}`}
        </Col>
      </Row>
      <Row className="text-fs-body-md mt-4 text-center " style={{ width: '100%' }}>
        <Col>
          <InputGroup className="search-sales-design">
            <InputGroup.Text id="basic-addon1" className="search-sales-icon">
              <BsSearch color='white' />
            </InputGroup.Text>
            <Form.Control
              className="search-sales-input text-fs-body-sm white-placeholder"
              type="text"
              placeholder={searchPlaceholder}
              aria-label="text"
              aria-describedby="basic-addon1"
              value={filterInput}
              onChange={(e) => setFilterInput(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
    </Container>
  );
}
const mapStateToProps = (state) => {
  return {
    filteredTokens: state.tokenReducer.filteredTokens,
    filterInput: state.tokenReducer.filterInput,
    tokenSortData: state.tokenReducer.tokenSortData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    filterTokens: (payload) => {
      dispatch(filterTokensAction(payload));
    },
    sortingTokens: (payload) => {
      dispatch(sortingTokensAction(payload));
    },
    setFilterInput: (payload) => {
      dispatch(setFilterInputAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerSales);
